import { render, staticRenderFns } from "./bAction.vue?vue&type=template&id=4bc203fc"
import script from "./bAction.vue?vue&type=script&lang=js"
export * from "./bAction.vue?vue&type=script&lang=js"
import style0 from "./bAction.vue?vue&type=style&index=0&id=4bc203fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports